import { MessageCircle } from 'lucide-react'

export default function BenBubble({ onOpen }) {
  return (
    <button
      onClick={onOpen}
      aria-label="Demandez à Ben"
      className="ben-bubble"
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 9998,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '14px 22px',
        border: 'none',
        borderRadius: '50px',
        background: 'linear-gradient(135deg, #2F2F84 0%, #6466B0 100%)',
        color: '#fff',
        fontFamily: 'Inter, sans-serif',
        fontSize: '0.95rem',
        fontWeight: 600,
        cursor: 'pointer',
        boxShadow: '0 8px 32px rgba(47, 47, 132, 0.4)',
        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)'
        e.currentTarget.style.boxShadow = '0 12px 40px rgba(47, 47, 132, 0.5)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow = '0 8px 32px rgba(47, 47, 132, 0.4)'
      }}
    >
      <MessageCircle size={20} />
      <span className="ben-bubble-label">Demandez à Ben</span>
    </button>
  )
}
